import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Chip } from '@mui/material';
import './EntitiesList.scss';

const EntitiesList = ({ items, onEdit, onDelete, canEdit, toPrefix }) => {
  return (
    <div className="entities-list">
      {items.map(item => (
        <Link
          key={item._id}
          to={`/${toPrefix}/${item._id}`}
          className="entity-item"
        >
          <div className="entity-content">
            <div className="entity-info">
              <span className="entity-name">{item.name}</span>
              {canEdit && canEdit(item) && (
                <div className="entity-actions">
                  {onEdit && (
                    <FontAwesomeIcon
                      icon={faEdit}
                      onClick={(e) => {
                        e.preventDefault();
                        onEdit(e, item._id);
                      }}
                      className="action-icon"
                    />
                  )}
                  {onDelete && (
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={(e) => {
                        e.preventDefault();
                        onDelete(e, item);
                      }}
                      className="action-icon"
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

EntitiesList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string)
  })).isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  canEdit: PropTypes.func,
  toPrefix: PropTypes.string.isRequired,
};

export default EntitiesList;